<template>
  <div class="page-template add-page deliver-add order-add-page">
    <div class="page-title">{{ title }}
    </div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button v-if="this.$route.query.auditStatus === '20'" :disabled="true" @click="submitAuth" type="primary"
                 plain>保存
      </el-button>
      <el-button v-else @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="examineAndVerify" type="primary" plain :disabled="formModel.auditStatus === null">审核
      </el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form v-show="complexShow" ref="listOperationForm" :formOptions="listFormOptions"
                         @valueChange="listFormValueChange"></list-operation-form>
    <div class="search-goods-box">
      <el-input id="goodsText"
                placeholder="条码/自编码/助记码"
                v-model="goodsTxt"
                class="search-goods-input"
                @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <!--<div class="el-icon-search more-btn" @click="search"></div>-->
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good">选择商品</el-button>
      <!--<el-button @click="downloadTemplate" type="primary" plain>下载模板</el-button>-->
      <!--<el-button @click="importData" type="primary" plain>导入商品</el-button>-->
      <el-button @click="openImport" type="primary" plain>导入商品</el-button>
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog
      title="商品列表"
      :visible.sync="listShow"
      width="1200px"
      height="800"
      :close-on-click-modal="false">
      <good-list
        v-if="listShow"
        ref="goodsListOperation"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :otherParam="otherParam"
        :tableOptions="tableOptions"
        @selectSubmit="rowsSelectSubmit"
        :selectUrl="selectUrl"
        :listTableData="listTableData"></good-list>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="importShow" custom-class="importDialog" :close-on-click-modal="false">
      <import-template v-if="importShow" ref="importTemplate" :importShow="importShow"
                       @importFile="importData" @downTemplate="downloadTemplate"></import-template>
    </el-dialog>
  </div>
</template>
<script>
  // 商品列表组件
  import goodList from '@/components/business/goodList';
  // 添加要货单组件
  import listOperationNew from "@/components/template/listOperationNew";
  // 要货单搜索组件
  import listOperationForm from '@/components/template/listOperationForm';
  import userPower from '@/mixin/userPower';

  import api from '@/config/api';

  // 导入模版组件
  import importTemplate from '@/components/business/importTemplate';

  export default {
    mixins: [userPower],
    components: {
      listOperationNew,
      goodList,
      listOperationForm,
      importTemplate
    },
    data() {
      return {
        importShow: false,
        isCheck: false,
        complexShow: true,
        goodsTxt: "",
        goodListSelect: false,
        listTableData: [],
        title: '',
        goodsCopyList: [],
        listShow: false,
        goodList: [],
        dialogShow: false,
        isSelectDeliverWarehouse: true,
        isSelectRequireWarehouse: true,
        isSelectDeliverStore: true,
        isSelectRequireStore: true,
        selectUrl: {url: api.warehouse.warehouseGoods},
        otherParam: {statusList: [10, 20, 30], isOpenCombination: 2, noSonCombinationGoods: true},
        isClearTableData: true,
        formModel: {
          auditStatus: null
        },
        // 添加头部字段
        listFormOptions: {
          statusOption: {
            prop: 'auditStatus',
            statusImg: {
              20: '/static/checked.png',
              10: '/static/un-check.png'
            },
            right: '100px',
            top: '-50px'
          },
          labelWidth: '130px',
          columns:
            [
              {
                prop: 'id',
                hidden: true
              },
              {
                label: '业务单号',
                type: 'input',
                prop: 'orderNo',
                span: 8,
                disabled: true
              },
              // {
              //   label: '调拨级别',
              //   type: 'select',
              //   prop: 'relateType',
              //   data: this.$utils.getCacheStatus('dnRequireOrder.relateType'),
              //   change: this.loginTypeChange,
              //   disabled: false,
              //   span: 12,
              // },
              {
                label: "调出门店",
                type: "storeInputDialog",
                prop: "deliverStoreId",
                span: 8,
                disabled: false,
                isHasAll: true, // 下拉选择添加‘总部’字段
              },
              {
                label: '调出仓库',
                type: 'warehouseInputDialog',
                prop: 'deliverWarehouseId',
                data: [],
                span: 8,
                disabled: false,
                change: this.warehouseChange
              },
              {
                label: '调入门店',
                type: 'storeInputDialog',
                prop: 'requireStoreId',
                // data: [],
                span: 8,
                // isHasAll: true,
                // url: api.system.seStore,
                // change: this.getRequireWarehouseId,
                disabled: false
              },
              {
                label: '调入仓库',
                type: 'warehouseInputDialogTwo',
                prop: 'requireWarehouseId',
                // data: [],
                span: 8
              },
              {
                label: '引用单号',
                type: 'orderDialog',
                prop: 'requireOrderNo',
                data: [],
                span: 8,
                url: api.delivery.requisitionQuote,
                labelKey: 'orderNo',
                uniqueKey: 'orderNo',
                disabled: true,
                change: this.queryRelatedOrderNo
              },
              {
                label: '经手人',
                type: 'input',
                prop: 'handlerName',
                maxLength: 16,
                span: 8
              },
              //   {
              //   label: '是否配送：',
              //   prop: 'isDistribution',
              //   type: 'radio',
              //   span: 12,
              //   defaultValue: 10,
              //   data: [{label: '是', value: 10}, {label: '否', value: 20}]
              // },
              {
                label: '备注',
                type: 'input',
                maxLength: 16,
                prop: 'remarks',
                span: 8
              }]
        },
        // 添加表格字段
        listColumns: {
          disabled: false,
          // 是否显示索引
          indexShow: true,
          summaryColumns: ['blitemNum', 'subtotalAmount'],
          columns: [
            {label: '操作', type: 'operation', width: 100, prop: 'operation'},
            {label: '序号', type: 'index', width: 60, prop: 'idx'},
            {
              label: '条码',
              prop: 'barCode',
              // type: 'input',
              width: '150',
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '60'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '60'
            },
            {
              label: '类别',
              prop: 'goodsCategoryName',
              width: '100'
            },
            {
              label: '品牌',
              prop: 'goodsBrandName',
              width: '100'
            },
            {
              label: '配送价',
              prop: 'deliveryPrice',
              width: '100',
              type: 'inputNumber',
              change: this.updateData,
              max: 99999.99,
              precision: 2
            },
            {
              label: '数量',
              width: '100',
              prop: 'blitemNum',
              type: 'inputNumber',
              change: this.numChange,
              max: 9999.999,
              precision: 3
            },
            {
              label: '小计金额',
              prop: 'subtotalAmount',
              width: '100'
            },
            // {
            //   label: '当前门店库存',
            //   prop: 'inventoryNum',
            //   width: '120'
            // },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '80'
            },
            {
              label: '备注',
              prop: 'remarks',
              maxLength: 16,
              type: 'input',
              width: '200'
            },

          ],
          url: api.warehouse.blitem
        },
        // 表格信息配置
        tableOptions: {
          // 是否显示索引
          indexShow: true,
          // 自定义列索引
          indexMethod: (index) => {
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '200',
              align: 'center'
            },
            {
              label: '品名',
              prop: 'goodsName',
              width: '100',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '100',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '200',
              align: 'center'
            },
            {
              label: '配送价',
              prop: 'deliveryPrice',
              width: '150',
              align: 'center'
            }
          ],
          param: this.otherParam,
          url: api.archives.goodsInfoIncludeSpecs
        },
        checkIndex: ''
      }
    },
    created() {
      this.title = document.title + (this.$route.query.id ? '-编辑' : '-新增');
      if (this.$route.query.id) {
        this.getDetail();
      } else {
        this.$nextTick(() => {
          let warehouseId = this.$utils.getSysUser().warehouseId;
          this.$refs.listOperationForm.formModel.deliverWarehouseId = warehouseId;
          this.otherParam.deliverWarehouseId = warehouseId;
          this.isSelectDeliverWarehouse = false;
        })
      }
      // this.setRelateType(this.listFormOptions.columns);
      this.setDnStoreId(this.listFormOptions.columns);
    },
    methods: {
      complexFunc() {
        if (!this.isCheck) {
          this.complexShow = !this.complexShow;
        }
      },
      listFormValueChange(value, column) {
        if (column.prop == "deliverStoreId") {
          this.listFormOptions.columns.filter(
            item => item.prop === "deliverWarehouseId"
          )[0].params = {storeId: value.id};
        }
        if (column.prop == "requireStoreId") {
          this.listFormOptions.columns.filter(
            item => item.prop === "requireWarehouseId"
          )[0].params = {storeId: value.id};
        }
        if (column.prop == "deliverStoreId") {
          this.otherParam.deliverStoreId = value.id;
          this.$refs.listOperationForm.formModel.deliverStoreId = value.id;
          // this.$refs.listOperationForm.$refs.warehouseInputDialog[0].initData();
          if (value.warehouseId) {
            this.$refs.listOperationForm.formModel.deliverWarehouseId = value.warehouseId;
            this.otherParam.deliverWarehouseId = value.warehouseId;
            this.isSelectDeliverWarehouse = false;
          }
        } else if (column.prop == "deliverWarehouseId") {
          this.otherParam.deliverWarehouseId = value;
          this.isSelectDeliverWarehouse = false;
        } else if (column.prop == "requireStoreId") {
          this.$refs.listOperationForm.$refs.warehouseInputDialogTwo[0].initData();
          this.otherParam.requireStoreId = value.id;
          this.$refs.listOperationForm.formModel.requireStoreId = value.id;
          this.isSelectRequireStore = false;
          if (value.warehouseId) {
            this.otherParam.requireWarehouseId = value.warehouseId;
            this.isSelectRequireWarehouse = false;
            this.$refs.listOperationForm.formModel.requireWarehouseId = value.warehouseId;
          }
        } else if (column.prop == "requireWarehouseId") {
          this.otherParam.requireWarehouseId = value;
          this.isSelectRequireWarehouse = false;
        }
      },
      search() {
        if (this.goodsTxt === '' || this.goodsTxt === null) return;
        this.otherParam.otherName = this.goodsTxt;
        if (this.isSelectDeliverWarehouse) {
          this.$message.warning("请选择调出仓库");
          return;
        }
        if (this.isSelectRequireStore) {
          this.$message.warning("请选择调入门店");
          return;
        }
        if (this.isSelectRequireWarehouse) {
          this.goodsTxt = '';
          this.$message.warning("请选择调入仓库");
          return;
        }
        let tableData = this.$refs.listOperationForm.formModel;
        if (tableData.deliverStoreId === tableData.requireStoreId) {
          this.$message.warning("调入门店和调出门店不能相同");
          return;
        }
        this.isCheck = true;
        this.$axios
          .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
          .then(res => {
            if (res.code === 200) {
              if (res.data.length > 0) {
                let tableData = res.data;
                if (tableData.length === 1) {
                  let row = tableData[0];
                  let tableList = this.$refs["listOperation"].getTabelData();
                  let flag = true;
                  if (tableList.length > 0) {
                    tableList.forEach(item => {
                      if (flag) {
                        if (item.barCode === row.barCode) flag = false;
                      }
                    });
                  }
                  if (!flag) {
                    this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                    return;
                  }
                  row.subtotalAmount = 0.00.toFixed(2);
                  row.blitemNum = 0.00.toFixed(3);
                  // this.$refs["listOperation"].addMoreRow(row, tableList.length);
                  this.$refs["listOperation"].setColumnData(row, tableList.length);
                  this.currentTableList = this.$refs["listOperation"].getTabelData();
                  this.$message.success("商品添加成功");
                } else {
                  this.checkGoods();
                }
              } else {
                this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
              }
            } else {
              this.$message({type: "error", message: res.msg});
            }
          })
          .catch(err => {
          }).finally(() => {
          this.clearQueryParam();
          this.isCheck = false;
        });


      },
      clearQueryParam() {
        this.goodsTxt = '';
        this.otherParam.otherName = '';
      },
      // 编辑回显数据
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.delivery.transferring + '?id=' + this.$route.query.id, {})
          .then(data => {
            this.loading = false;
            if (data.code === 200) {
              this.$nextTick(() => {
                // 为头部表单赋值
                this.$refs.listOperationForm.formModel = data.data;
                this.formModel.auditStatus = data.data.auditStatus;
                if (data.data.type === 10) {
                  this.listFormOptions.columns.filter(item => item.prop === 'deliverStoreId')[0].disabled = true;
                  this.listFormOptions.columns.filter(item => item.prop === 'requireStoreId')[0].disabled = true;
                  this.listFormOptions.columns.filter(item => item.prop === 'requireWarehouseId')[0].disabled = true;
                  this.listFormOptions.columns.filter(item => item.prop === 'deliverWarehouseId')[0].disabled = true;
                }
                // 处理字段值与配置的表格值不一致的地方
                // 此处为示例，其他需要处理的值请各自根据业务处理
                data.data.goodsMapMVOList.map(item => {
                  item.id = item.goodsId;
                  item.name = item.goodsName;
                  item.barCode = item.goodsBarCode;
                  item.specs = item.goodsSpecs;
                  item.unitName = item.goodsUnitName;
                  item.inventoryNum = item.goodsInventoryNum;
                  item.blitemNum = item.goodsNum;
                });
                this.goodsCopyList = this.$utils.deepClone(
                  data.data.goodsMapMVOList
                );
                this.isClearTableData = false;
                this.isSelectRequireWarehouse = false;
                this.isSelectDeliverWarehouse = false;
                this.isSelectRequireStore = false;

                // 为表格赋值
                this.$refs['listOperation'].addMoreRow(data.data.goodsMapMVOList, 0);
                this.currentTableList = this.$refs['listOperation'].getTabelData();
                // this.loginTypeChange({relateType: data.data.relateType});
                this.getWarehouse({deliverStoreId: data.data.deliverStoreId});
                this.getRequireWarehouseId({requireStoreId: data.data.requireStoreId});
              });
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },

      // 通过数量计算小计金额
      numChange(row, index) {
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.blitemNum === '' || row.blitemNum == null) {
          row.blitemNum = rowData.blitemNum.toString();
          return;
        }
        if (this.goodsCopyList.length !== 0) {
          this.goodsCopyList.map((item) => {
            if (item.barCode === row.barCode) {
              if (row.blitemNum > item.goodsNum) {
                this.$confirm(
                  row.name +
                  '：现可调拨的数量最多为' +
                  item.goodsNum +
                  '，多余部分请重新制定！',
                  '提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }
                )
                  .then(() => {
                    row.blitemNum = item.goodsNum;
                    this.updateData(row, index);
                  })
                  .catch(() => {
                    row.blitemNum = item.goodsNum;
                    this.updateData(row, index);
                  });
              } else {
                this.updateData(row, index);
              }
            }
          });
        } else {
          this.updateData(row, index);
        }
      },

      updateData(row, index) {
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.deliveryPrice === '' || row.deliveryPrice == null) {
          row.deliveryPrice = rowData.deliveryPrice.toString();
          return;
        }
        if (row.subtotalAmount) {
          row.subtotalAmount = parseFloat(row.deliveryPrice * row.blitemNum).toFixed(2);
        }
        this.$refs['listOperation'].setCountData(row, index);
      },

      // 选择某行数据
      rowCheck(row) {
        if (this.isSelectDeliverWarehouse) {
          this.$message.warning("请选择调出仓库");
          return;
        }
        if (this.isSelectRequireStore) {
          this.$message.warning("请选择调入门店");
          return;
        }
        if (this.isSelectRequireWarehouse) {
          this.goodsTxt = '';
          this.$message.warning("请选择调入仓库");
          return;
        }
        this.listShow = false;
        row.subtotalAmount = 0.00.toFixed(2);
        row.blitemNum = 0.00.toFixed(3);
        this.$refs['listOperation'].setColumnData(row, this.checkIndex);
        this.currentTableList = this.$refs['listOperation'].getTabelData();

      },
      validePirce(val) {
        const priceArray = ['buyPrice', 'deliveryPrice', 'lowestPrice', 'plusVipPrice', 'retailPrice', 'tradePrice', 'vipPrice'];
        if (priceArray.includes(val)) {
          return true
        } else {
          return false
        }
      },
      valideMount(val) {
        const mountArray = ['blitemNum'];
        if (mountArray.includes(val)) {
          return true
        } else {
          return false
        }
      },

      // 商品多选，确认事件
      submitAuth() {
        if (!this.isCheck) {
          let tableList = this.$refs['listOperation'].getTabelData();
          let orderNumber = 1;
          if (tableList.length === 0) {
            this.$message.warning("表格数据为空,无法保存");
            return false;
          }
          tableList.map(item => {
            item.orderNumber = orderNumber++;
            item.goodsNum = item.blitemNum;
          });
          let totalParam = this.$refs['listOperation'].getSumData();
          totalParam.billAmount = totalParam.subtotalAmount;
          let headParam = this.$refs.listOperationForm.getFormModel();
          if (headParam.deliverStoreId === headParam.requireStoreId) {
            this.$message.warning("调入门店和调出门店不能相同");
            return;
          }
          headParam.auditStatus = this.formModel.auditStatus;
          let searchParam = {
            ...{goodsMapMVOList: tableList}, ...totalParam, ...headParam
          };
          let axiosUrl = '';
          if (headParam.id) {
            searchParam.operateFlag = 'update';
            axiosUrl = '/api/eros/dn/dnAllocationOrder/updateallocationorder';
          } else {
            axiosUrl = '/api/eros/dn/dnAllocationOrder/insertallocationorder';
          }
          if (headParam.deliverWarehouseId === undefined) {
            this.$message({message: '请选择调出仓库！', type: 'warning'});
          } else {
            if (headParam.requireStoreId === undefined) {
              this.$message({message: '请选择调入门店！', type: 'warning'});
            } else {
              let length = 0;
              let priceLength = 0;
              tableList.map(table => {
                if (table.goodsNum === 0) {
                  length = length + 1;
                }
                if (table.deliveryPrice === 0) {
                  priceLength = priceLength + 1;
                }
              });
              let priceFlag = false
              let mountFlag = false
              tableList.map(item => {
                for (let key in item) {
                  if (this.validePirce(key)) {
                    if (item[key] > 99999.99) {
                      priceFlag = true
                    }
                  }
                  if (this.valideMount(key)) {
                    if (item[key] > 9999.999) {
                      mountFlag = true
                    }
                  }
                }
              })
              if (mountFlag) return this.$message.warning('数量相关不能超过9999.999')
              if (priceFlag) return this.$message.warning('价格不能超过99999.99')
              if (length > 0) {
                this.$message({message: '存在数量为0的商品，不能进行保存/审核！', type: 'warning'});
              } else {
                if (priceLength > 0) {
                  this.$message({message: '存在配送价为0的商品，不能进行保存/审核！', type: 'warning'});
                } else {
                  this.saveData(axiosUrl, searchParam);
                }
              }
            }
          }
        }
      },
      saveData(axiosUrl, searchParam) {
        this.$confirm('是否保存，请确认数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '提交中，请稍候...',
            background: 'rgba(225, 225, 225, 0.8)'
          });
          this.$axios
            .fetchPost(axiosUrl, searchParam)
            .then(data => {
              this.loading = false;
              if (data.code === 200) {
                this.dialogShow = false;
                // this.$router.push({path: '/delivery/transferring'});
                this.$refs.listOperationForm.formModel = data.data;
                this.formModel.auditStatus = data.data.auditStatus;
                this.$set(this.formModel, 'isDistribution', data.data.isDistribution);
                // this.$message({message: '保存成功！', type: 'success'});
                this.$notify({
                  type: "success",
                  title: '保存操作',
                  message: '成功',
                  showClose: false,
                });
              } else {
                this.$message({message: data.msg, type: 'error'});
              }
            })
            .catch(err => {
              console.log(err);
              this.$message({message: '请求失败！', type: 'error'});
              this.loading = false;
            }).finally(() => {
            loading.close()
          })
        });
      },

      // 提交数据
      rowsSelectSubmit(rows) {
        this.listShow = false;
        rows.map(item => {
          item.subtotalAmount = '0.00';
        });
        let tableList = this.$refs['listOperation'].getTabelData();
        this.$refs['listOperation'].addMoreRow(rows, tableList.length);
        this.currentTableList = this.$refs['listOperation'].getTabelData();
        if (rows && rows.length > 0) {
          this.$message.success("商品添加成功");
        }
      },

      // 返回按钮事件
      beBack() {
        if (!this.isCheck) {
          this.$router.go(-1);
        }
      },

      // 刷新按钮事件
      refresh() {
        if (!this.isCheck) {
          this.$router.go(0);
        }
      },

      // 选择商品安装事件
      checkGoods(row) {
        if (this.isSelectDeliverWarehouse) {
          this.$message.warning("请选择调出仓库");
          return;
        }
        if (this.isSelectRequireStore) {
          this.$message.warning("请选择调入门店");
          return;
        }
        if (this.isSelectRequireWarehouse) {
          this.goodsTxt = '';
          this.$message.warning("请选择调入仓库");
          return;
        }
        let tableData = this.$refs.listOperationForm.formModel;
        if (tableData.deliverStoreId === tableData.requireStoreId) {
          this.$message.warning("调入门店和调出门店不能相同");
          return;
        }
        this.listShow = true;
        this.goodListSelect = true;
        this.listTableData = this.$refs['listOperation'].getTabelData()
        // this.$nextTick(() => {
        //   this.$refs['goodsListOperation'].getTableData(this.otherParam);
        // });

      },

      // 引用要货单单号
      queryRelatedOrderNo(formModel) {
        // this.$refs['listOperation'].clearTableData();
        let requireOrderNo = this.listFormOptions.columns.filter(item => item.prop === 'requireOrderNo')[0];
        requireOrderNo.data.map(item => {
          if (item.orderNo === formModel.requireOrderNo) {
            this.loading = true;
            this.$axios
              .fetchGet(api.delivery.requisition + '?id=' + item.id, {})
              .then(data => {
                this.loading = false;
                if (data.code === 200) {
                  this.$nextTick(() => {
                    // 为头部表单赋值
                    this.$refs.listOperationForm.formModel.requireOrderNo = data.data.orderNo;
                    this.$refs.listOperationForm.formModel.requireStoreId = data.data.requireStoreId;
                    this.$refs.listOperationForm.formModel.deliverStoreId = data.data.deliverStoreId;
                    // this.$refs.listOperationForm.formModel.remarks = data.data.remarks;
                    // 处理字段值与配置的表格值不一致的地方
                    // 此处为示例，其他需要处理的值请各自根据业务处理
                    data.data.goodsMapMVOList.map(item => {
                      item.id = item.goodsId;
                      item.name = item.goodsName;
                      item.barCode = item.goodsBarCode;
                      item.specs = item.goodsSpecs;
                      item.unitName = item.goodsUnitName;
                      item.blitemNum = item.goodsNum;
                      item.inventoryNum = item.goodsInventoryNum;
                    });
                    // 为表格赋值
                    this.$refs['listOperation'].addMoreRow(data.data.goodsMapMVOList, 0);
                    this.currentTableList = this.$refs['listOperation'].getTabelData();

                  });
                } else {
                  this.$message({message: data.msg, type: 'error'});
                }
              })
              .catch(err => {
                console.log(err);
                this.$message({message: '请求失败！', type: 'error'});
                this.loading = false;
              });
          }
        })
      },

      // 审核按钮事件(10：调出审核 30：调入审核)
      examineAndVerify() {
        if (!this.isCheck) {
          this.$confirm('是否审核数据，请确认?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              let tableList = this.$refs['listOperation'].getTabelData();
              let errorList = [];
              let orderNumber = 1;
              tableList.map(item => {
                item.orderNumber = orderNumber++;
                if (item.goodsInventoryNum - item.goodsNum < 0) {
                  errorList.push(item)
                }
                item.goodsNum = item.blitemNum;
                item.goodsBarCode = item.barCode;
              });
              let totalParam = this.$refs['listOperation'].getSumData();
              totalParam.billAmount = totalParam.subtotalAmount;
              let headParam = this.$refs.listOperationForm.getFormModel();
              let searchParam = {
                ...{goodsMapMVOList: tableList}, ...totalParam, ...headParam
              };
              if (errorList.length === 0) {
                this.submitData(searchParam);
              } else {
                this.$confirm('存在要货数量大于现有库存的商品，是否继续审核?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.submitData(searchParam);
                })
              }
            })
            .catch(() => {
              // this.$message({type: 'info', message: '已取消删除'});
            });
        }
      },

      submitData(searchParam) {
        searchParam.operateFlag = 'examine';
        const loading = this.$loading({
          lock: true,
          text: '提交中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios.fetchPost('/api/eros/dn/dnAllocationOrder/updateallocationorder', searchParam).then(data => {
          this.loading = false;
          if (data.code === 200) {
            console.log(data)
            if (data.data.notExistGoods && data.data.notExistGoods === true) {
              this.$nextTick(() => {
                // 为头部表单赋值
                this.$refs.listOperationForm.formModel = data.data;
                this.formModel.auditStatus = data.data.auditStatus;
                if (data.data.type === 10) {
                  // this.listFormOptions.columns.filter(item => item.prop === 'relateType')[0].disabled = true;
                  this.listFormOptions.columns.filter(item => item.prop === 'deliverStoreId')[0].disabled = true;
                  this.listFormOptions.columns.filter(item => item.prop === 'requireStoreId')[0].disabled = true;
                  this.listFormOptions.columns.filter(item => item.prop === 'requireWarehouseId')[0].disabled = true;
                  this.listFormOptions.columns.filter(item => item.prop === 'requireOrderNo')[0].disabled = true;
                  // this.listFormOptions.columns.filter(item => item.prop === 'deliverWarehouseId')[0].disabled = true;
                }
                // 处理字段值与配置的表格值不一致的地方
                // 此处为示例，其他需要处理的值请各自根据业务处理
                data.data.goodsMapMVOList.map(item => {
                  item.id = item.goodsId;
                  item.name = item.goodsName;
                  item.barCode = item.goodsBarCode;
                  item.specs = item.goodsSpecs;
                  item.unitName = item.goodsUnitName;
                  item.inventoryNum = item.goodsInventoryNum;
                  item.blitemNum = item.goodsNum;
                });
                this.goodsCopyList = this.$utils.deepClone(
                  data.data.goodsMapMVOList
                );
                this.isClearTableData = false;
                this.isSelectRequireWarehouse = false;
                this.isSelectDeliverWarehouse = false;
                this.isSelectRequireStore = false;
                // 为表格赋值
                this.$refs['listOperation'].addMoreRow(data.data.goodsMapMVOList, 0);
                this.getWarehouse({deliverStoreId: data.data.deliverStoreId});
                this.getRequireWarehouseId({requireStoreId: data.data.requireStoreId});
                this.$message({message: '审核失败:红色标识商品不允许调往总部，请删除！', type: 'warning'});
              });
            } else {
              this.$notify({
                type: "success",
                title: '审核操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '审核成功!', type: 'success'});
              this.dialogShow = false;
              this.$router.push({path: '/delivery/transferring'});
            }
          } else {
            if (data.errorMsg) {
              this.$message({message: data.errorMsg, type: 'error'});
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }
        }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        }).finally(() => {
          loading.close()
        })
      },
      loginTypeChange(form) {
        if (form.relateType === 10) {
          // 选择总部的时候，查询商户相应仓库
          this.listFormOptions.columns.filter(item => item.prop === 'deliverWarehouseId')[0].hidden = false;
          this.listFormOptions.columns.filter(item => item.prop === 'deliverStoreId')[0].hidden = true;
          // 根据商户获取相应仓库
          this.listFormOptions.columns.filter(item => item.prop === 'deliverWarehouseId')[0].data = [];
          this.$axios.fetchPost(api.warehouse.warehouse + '/warehouse/list', {relateType: form.relateType}).then(data => {
            if (data.code === 200) {
              this.$refs.listOperationForm.formModel.deliverWarehouseId = '';
              this.listFormOptions.columns.filter(item => item.prop === 'deliverWarehouseId')[0].data = data.data;
              data.data.map(item => {
                if (item.defaultState === true) {
                  this.$refs.listOperationForm.formModel.deliverWarehouseId = item.id;
                  this.otherParam.warehouseId = item.id;
                }
              })
            }
          })
        } else {
          // 选择门店的时候，查询商户相应的门店
          this.listFormOptions.columns.filter(item => item.prop === 'deliverStoreId')[0].hidden = false;
          this.listFormOptions.columns.filter(item => item.prop === 'deliverWarehouseId')[0].hidden = false;
          this.listFormOptions.columns.filter(item => item.prop === 'deliverWarehouseId')[0].data = [];
          this.listFormOptions.columns.filter(item => item.prop === 'deliverStoreId')[0].data = [];
          this.$axios.fetchPost(api.system.seStore + '/list', {}).then(data => {
            if (data.code === 200) {
              this.$refs.listOperationForm.formModel.deliverWarehouseId = '';
              this.$refs.listOperationForm.formModel.deliverStoreId = '';
              this.listFormOptions.columns.filter(item => item.prop === 'deliverStoreId')[0].data = data.data;
              let user = this.$utils.getSysUser();
              this.$refs.listOperationForm.formModel.deliverStoreId = user.storeId;
            }
          })
        }
      },
      getWarehouse(form) {
        if (form.requireStoreId === form.deliverStoreId) {
          this.$message.warning("调入门店不能和调出门店相同");
          form.requireStoreId = '';
          form.requireWarehouseId = '';
        }
        // 根据门店获取相应仓库
        this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.deliverStoreId}).then(data => {
          if (data.code === 200) {
            this.listFormOptions.columns.filter(item => item.prop === 'deliverWarehouseId')[0].data = data.data;
            data.data.map(item => {
              if (item.defaultState === true) {
                this.$refs.listOperationForm.formModel.deliverWarehouseId = item.id;
                this.otherParam.warehouseId = item.id;
              }
            })
          }
        });
        this.otherParam.storeId = form.deliverStoreId
      },
      getRequireWarehouseId(form) {
        if (form.requireStoreId === form.deliverStoreId) {
          this.$message.warning("调入门店不能和调出门店相同");
          form.requireStoreId = '';
        } else {
          // 根据门店获取相应仓库
          this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.requireStoreId}).then(data => {
            if (data.code === 200) {
              this.listFormOptions.columns.filter(item => item.prop === 'requireWarehouseId')[0].data = data.data;
              data.data.map(item => {
                if (item.defaultState === true) {
                  this.$refs.listOperationForm.formModel.requireWarehouseId = item.id;
                }
              })
            }
          });
          this.isSelectRequireWarehouse = false;
        }
      },
      warehouseChange(data) {
        if (this.isClearTableData) {
          this.$refs['listOperation'].clearTableData();
        } else {
          this.isClearTableData = true;
        }
        this.otherParam.warehouseId = data.deliverWarehouseId;
      },
      downloadTemplate() {
        if (!this.isCheck) {
          this.$axios.fetchPost(api.warehouse.downloadTemplate).then(data => {
            if (data.code === 200) {
              const elink = document.createElement('a');
              elink.href = data.data;
              elink.click();
              this.loadingExt = false;
              this.$notify({
                type: "success",
                title: '导出操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '导出成功', type: 'success'});
            } else {
              this.$notify({
                type: "error",
                title: '导出操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '导出异常', type: 'error'});
            }
          })
        }
      },
      importData() {
        if (!this.isCheck) {
          let tableData = this.otherParam;
          if (tableData.warehouseId) {
            this.$utils.uploadFile((file) => {
              this.loading = true;
              let formData = new FormData();
              formData.append('multipartFile', file);
              formData.append('warehouseId', tableData.warehouseId);
              this.$refs['listOperation'].clearTableData();
              const loading = this.$loading({
                lock: true,
                text: '提交中，请稍候...',
                background: 'rgba(225, 225, 225, 0.8)'
              });
              this.$axios
                .fetchPostGoodsExport(api.delivery.importGoods, formData)
                .then(data => {
                  if (data.code === 200) {
                    this.importShow = false;
                    // 为表格赋值
                    if (data.data.weWarehouseGoodsMapMVOList) {
                      data.data.weWarehouseGoodsMapMVOList.map(item => {
                        item.id = item.goodsId;
                        item.subtotalAmount = (item.blitemNum * item.purchasePrice).toFixed(2);
                      });
                      this.$refs['listOperation'].addMoreRow(data.data.weWarehouseGoodsMapMVOList, 0);
                    }
                    if (data.data.errorBatchId) {
                      this.exportErrorData(data.data.errorBatchId);
                    }
                  } else {
                    if (data.errorMsg) {
                      this.$message({message: data.errorMsg, type: 'error'});
                    } else {

                      this.$notify({
                        type: "error",
                        title: '导入操作',
                        message: '失败',
                        showClose: false,
                      });
                      // this.$message({message: '导入异常', type: 'error'});
                    }
                  }
                })
                .catch((err) => {
                  this.loading = false;
                  console.log(err);
                }).finally(() => {
                loading.close()
              })
            });
          } else {
            this.$message({message: '请选择调出仓库！', type: 'warning'});
          }
        }
      },
      exportErrorData(id) {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios.PostBlob(api.system.exportError + '?batchId=' + id, '').then(res => {
          if (res.status === 200) {
            const fileName = '调拨出库错误数据' + '_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            // this.$message.success("导出成功,文件名称:" + fileName);
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },

      setDnStoreId(params) {
        let user = this.$utils.getSysUser();
        let deliverStoreId = params.filter((item) => item.prop === 'deliverStoreId')[0];
        if (user.storeId) {
          deliverStoreId.disabled = true;
          deliverStoreId.defaultValue = user.storeId;
        } else {
          deliverStoreId.disabled = false;
          deliverStoreId.defaultValue = -1;
        }
      },
      openImport() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (!tableData.deliverStoreId) {
            this.$message.warning("请选择调出门店");
            return;
          }
          if (!tableData.deliverWarehouseId) {
            this.$message.warning("请选择调出仓库");
            return;
          }
          if (!tableData.requireStoreId) {
            this.$message.warning("请选择调入门店");
            return;
          }
          if (!tableData.requireWarehouseId) {
            this.$message.warning("请选择调入仓库");
            return;
          }
          if (tableData.deliverStoreId === tableData.requireStoreId) {
            this.$message.warning("调入门店和调出门店不能相同");
            return;
          }
          this.importShow = true;
        }
      },
    }
  }
</script>
<style scoped>
  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }

  /deep/ .importDialog {
    width: 640px;
    min-width: 640px;
  }
</style>



// WEBPACK FOOTER //
// src/page/delivery/TransferringAdd.vue